import { render, staticRenderFns } from "./EmployeeLibraryDialog.vue?vue&type=template&id=188b737a"
import script from "./EmployeeLibraryDialog.vue?vue&type=script&lang=js"
export * from "./EmployeeLibraryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports